import styled from 'styled-components';

export const Container = styled.div`
  h6 {
    margin-bottom: 0;
  }

  .menu-item-icon img {
    margin-top: 0.2rem;
    filter: invert(44%) sepia(45%) saturate(1827%) hue-rotate(128deg) brightness(93%) contrast(87%);
    width: 24px;
  }

  .menu-item-icon.icon-colored img {
    filter: none;
  }

  .badge-novidades-category {
    border-radius: 12px;
    padding: 0.01rem 1rem 0 1rem;
    margin: 0 0 0.2rem 1rem;
    font-size: 0.9rem;
    z-index: 1;
    color: ${(props) => props.theme.$white};
    background-color: ${(props) => props.theme.$dark_green};
    align-self: center;
  }

  .card-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    width: 10.3rem;
    height: 100px;
    position: relative;
    background-color: ${(props) => props.theme.$white};
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 8px;
    box-shadow: none !important;
    text-decoration: none;
    transition: transform 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      transform: translateY(-0.2rem);
      box-shadow: 0 0.1rem 0.5rem rgba(0, 0, 0, 0.1) !important;
      text-decoration: none !important;
    }

    @media only screen and (max-width: 768px) {
      display: block;
      width: 100%;
      min-height: 100px;
      height: auto;
    }

    @media only screen and (min-width: 1700px) {
      margin-top: 1rem !important;
      margin-bottom: 0 !important;
      margin-left: 0.25rem !important;
      margin-right: 0.25rem !important;
      width: 10.8rem;
    }

    p {
      flex-shrink: 0;
      margin: 0;
      line-height: 1.2;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 0.9rem;
      color: ${(props) => props.theme.$blue800};
    }

    .badge-novidade,
    .badge-assine {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 12px;
      font-size: 0.9rem;
      line-height: 1.4;
      padding: 0 0.85rem;
      white-space: nowrap;
      z-index: 1;
      top: -10px;
    }

    .badge-novidade {
      color: ${(props) => props.theme.$white};
      background-color: ${(props) => props.theme.$dark_green};
    }

    .badge-assine {
      color: ${(props) => props.theme.$white};
      background-color: ${(props) => props.theme.$gray600};
    }

    &.has-novidade .badge-assine {
      top: 30px;
    }
  }
`;
